<script setup lang="ts">
import TransportsWrapper from '@/components/transports/TransportsWrapper.vue';
import { RoleGroups } from '@/constants/Roles';
import { TransportType } from '@/constants/TransportType';

definePage({
  name: 'TransportsImport',
  meta: {
    title: 'pageTitles.importTransports',
    roles: RoleGroups.Transports
  }
});
</script>

<template>
  <TransportsWrapper :transport-type="TransportType.Import" />
</template>

<style scoped>

</style>